import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-title',
  templateUrl: 'rmt-title.html'
})
export class RmtTitleComponent {
  @Input() margin: boolean = true;
  @Input() titleId: string ='';
  
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/rmt-title/rmt-title.ts